<template lang="pug">
  div(class="text-red-600 flex")
    Icon.flex-none.mt-ds-xxs(
      :size="12"
      name="i:triangle-exclamation-solid")
    div(class="ml-ds-xxs text-base leading-normal")
      slot
</template>

<script lang="ts">
export default {
  name: "TextInputErrorRefined"
}
</script>
